import { useSetAtom } from "jotai";
import { useModals } from "src/components/Modals";
import { User } from "@CommonApi/users/list";
import { resetPasswordUserAtom } from "./atoms";

export const useResetUserPasswordModal = () => {
  const { openModal } = useModals();
  const setResetPasswordUser = useSetAtom(resetPasswordUserAtom);

  const openResetUserPasswordModal = (user: User) => {
    setResetPasswordUser(user);
    openModal("ResetUserPasswordModal");
  };

  return { openResetUserPasswordModal };
};
